var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gw-block"},[_c('div',{staticClass:"gw-block__body"},[_c('div',{staticClass:"gw-block__title"},[_vm._t("title")],2),_vm._v(" "),_vm._t("body")],2),_vm._v(" "),_c('div',{staticClass:"gw-block__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }